import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { ProductGroupData } from "../types";

export const createProductGroupApi = (userId: string, group: ProductGroupData) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/newprodgroup",
		params: {
			userId
		},
		data: group
	});

export default createProductGroupApi;
